import React, { useState } from 'react';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';
import AssetForm from './components/AssetForm';

const App = () => {
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
  };

  return (
    <div>
      {!user ? (
        <LoginForm onLogin={handleLogin} />
      ) : user.role === 'admin' ? (
        <Dashboard onLogout={handleLogout} />
      ) : user.role === 'employee' ? (
        <AssetForm onLogout={handleLogout} />
      ) : (
        <div>
          <p>Unknown role: {user.role}</p>
          <button onClick={handleLogout}>Logout</button>
        </div>
      )}
    </div>
  );
};

export default App;
